<template>
	<!-- <div> -->
	<div class="bg-blue height28 border-radius4 padding-left12 padding-right12 flex-center color-white ComButton"
		@click="btnClick">
		{{name}}
	</div>
	<!-- </div> -->
</template>

<script>
	export default {
		name: 'ComButton',
		props: {
			name: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				keyWord: ''
			}
		},
		methods: {
			btnClick() {
				this.$emit('btnClick')
			}
		},
	}
</script>

<style lang="scss" scoped>
	.ComButton {
		cursor: pointer;

		&:hover {
			opacity: .8;
		}
	}
</style>